export { default as redCross } from '~/assets/images/red-cross.svg'
export { default as greenAccept } from '~/assets/images/green-accept.svg'
export { default as reviewAvatar } from '~/assets/images/anatomy/review_avatar1.png'
export { default as reviewStars } from '~/assets/images/anatomy/stars-5.svg'

export const HALF_ANIMATION_DURATION = 1000

export const POPUP_QUESTION_KEYS = [
  'first',
  'second',
  'third',
  'fourth',
] as const

export const PROGRESS_MIDPOINTS = [49, 55, 68, 79] as const
